export const openFullScreenVersion = (
  isFullScreenVersion: boolean,
  setFullScreenVersion: (value: boolean) => void
) => {
  setFullScreenVersion(!isFullScreenVersion);

  const serviceElement = document.querySelector(
    '.work-schedule-content-layout'
  );
  const pageHeaderElement = serviceElement?.querySelector(
    '.ant-layout-header.header'
  );
  const pageContentElement = serviceElement?.querySelector(
    '.ant-layout-content.content'
  );
  const sidebarAndContent = serviceElement?.querySelector(
    '.sidebar-and-content'
  );
  const footerElement = serviceElement?.querySelector('.footer-both-modes');

  if (!isFullScreenVersion) {
    (pageHeaderElement as HTMLElement).style.display = 'none';
    (pageContentElement as HTMLElement).style.margin = '0';
    (sidebarAndContent as HTMLElement).style.height = 'calc(100vh - 130px)';

    if ((footerElement as HTMLElement)?.style) {
      (footerElement as HTMLElement).style.width = 'auto';
    }
  } else {
    (pageHeaderElement as HTMLElement).style.display = 'block';
    (pageContentElement as HTMLElement).style.margin = '24px 16px';
    (sidebarAndContent as HTMLElement).style.height =
      'calc(100vh - 195px - 40px)';
  }
};
